import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/init.css'
import 'swiper/dist/css/swiper.css'
// import 'element-ui/lib/theme-chalk/index.css';
// import 'lib-flexible'
// import http from './api/http'
import API from './api/api'
import { Pagination, Input } from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Distpicker from 'v-distpicker'
import axios from 'axios'
import wx from "weixin-js-sdk";
import NProgress from 'nprogress' // 引入nprogress插件
import 'nprogress/nprogress.css'  // 这个nprogress样式必须引入
// import VueResource from 'vue-resource'
// Vue.use(VueResource)
import 'vant/lib/index.css';
import { Dialog } from 'vant';
import { Toast } from 'vant';
import { getQueryString } from "@/utils/common.js";
Vue.use(Toast);
Vue.use(Dialog);
NProgress.configure({ showSpinner: false });
Vue.prototype.$ajax = axios
// Vue.http.options.emulateJSON = true
router.beforeEach((to, from, next) => {
  NProgress.start();
  // 微信登录回调不读hash，所以要在根目录或者全局捕捉
  let wxCode = getQueryString("wx_code");
  let wxParams = getQueryString("wx_params");
  if(wxCode&&wxParams){
    let paramList = wxParams.split(';');
    let routePath = '';
    let routeQuery = '?code='+wxCode;
    paramList.map((item,index)=>{
      let kv = item.split(':');
      let k = kv[0];
      let v = kv[1];
      if(k==='routepath'){
        routePath = v;
      }else{
        if(index===0){
          routeQuery = routeQuery+k+'='+v;
        }else{
          routeQuery = routeQuery+'&'+k+'='+v;
        }
      }
    });
    location.href = encodeURI(location.origin + '/#/' + routePath + routeQuery);
    return false;
  }
  // 新官网上线后，这边的非功能性页面已被废弃，统一跳转新官网首页
  if(
    to.name==='Home'||
    to.name==='MusicwowApp'||
    to.name==='initiation'||
    to.name==='Teaching'||
    to.name==='Admin'||
    to.name==='Musicwow'||
    to.name==='Company'||
    to.name==='Dynamic'||
    to.name==='Contact'||
    to.name==='Joinus'
  ){
    window.location.href="https://www.musicwow.com";
    return false;
  }
  /*路由发生改变修改页面的title */
  if (!!to.meta.title) {
    document.title = to.meta.title
  }
  next();
});
router.afterEach((to) => {
  NProgress.done();
  // 设置微信分享
  setTimeout(() => {
    let title = '音乐窝官网';
    let desc = '多一种沟通方式；\r\n咨询电话：400~661~8883';
    let timeLine = '音乐窝官网';
    if (to.meta) {
      if (to.meta.title) {
        title = to.meta.title;
      }
      if (to.meta.description) {
        desc = to.meta.description;
      }
      if (to.meta.timeLine) {
        timeLine = to.meta.timeLine;
      }
    }
    let wxConfig = store.state.wxConfig
    if (wxConfig) {
      wx.config({
        appId: wxConfig.app_id,
        timestamp: wxConfig.timestamp,
        nonceStr: wxConfig.nonce_str,
        signature: wxConfig.signature,
        jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"],
      });
      wx.ready(function () {
        wx.updateTimelineShareData({
          title: timeLine,
          link: location.href,
          imgUrl: 'https://aliyunosszs.musicwow.com/0F1A1F6482E1C5BD175751E59AC57B16.png',
          success: function () {
            console.log("设置成功");
          },
        });
        wx.updateAppMessageShareData({
          title: title,
          desc: desc,
          link: location.href,
          imgUrl: 'https://aliyunosszs.musicwow.com/0F1A1F6482E1C5BD175751E59AC57B16.png',
          success: function () {
            console.log("设置成功");
          },
        });
      });
    } else {
      axios({
        method: "post",
        url: process.env.VUE_APP_CONT_API + "api/v1/wechat/js_config",
        headers: {
          "X-DEVICE-TYPE": "5",
          "X-APP-NAME": "musicwow",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        params: {
          app_id: 'wx4d3ccd23d6464806',
          url: location.href
        }
      }).then((res) => {
        // console.log(res);
        if (res.data.error_code == 0) {
          store.commit('SET_WXCONFIG', res.data.data);
          wx.config({
            appId: res.data.data.app_id,
            timestamp: res.data.data.timestamp,
            nonceStr: res.data.data.nonce_str,
            signature: res.data.data.signature,
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"],
            openTagList:['wx-open-launch-weapp']
          });
          wx.ready(function () {
            wx.updateTimelineShareData({
              title: timeLine,
              link: location.href,
              imgUrl: 'https://aliyunosszs.musicwow.com/0F1A1F6482E1C5BD175751E59AC57B16.png',
              success: function () {
                console.log("设置成功");
              },
            });
            wx.updateAppMessageShareData({
              title: title,
              desc: desc,
              link: location.href,
              imgUrl: 'https://aliyunosszs.musicwow.com/0F1A1F6482E1C5BD175751E59AC57B16.png',
              success: function () {
                console.log("设置成功");
              },
            });
          });
        }
      });
    }
  });
});

Vue.component('v-distpicker', Distpicker)
Vue.prototype.$API = API


Vue.use(VueAwesomeSwiper)
Vue.use(Pagination);
Vue.use(Input);
Vue.config.productionTip = false
// Vue.http.interceptors.push((request, next) => {

//   request.credentials = true;

//   next();
// });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


